import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import './ServiceRequestFormSuite.scss';
import { fetchPropertySuites,clearSuites } from '../../store/actions/suites';
import { fetchSuiteAssets,clearAssets } from '../../store/actions/assets';
import { fetchProperties } from '../../store/actions/properties';
import { fetchSuiteById } from '../../store/actions/suites';
import { selectProperties, selectPropertyById } from '../../store/selectors/properties';
import { selectSuites } from '../../store/selectors/suites';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { selectSuiteById } from '../../store/selectors/suites';
import { setServiceRequestFormData, setServiceRequestFormNextStep, setServiceRequestFormStep, exitServiceRequestForm } from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import Select from '../Select';

import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectCommonAreaById, selectPropertyCommonAreas } from '../../store/selectors/propertyCommonAreas';
import { selectCommonAreaAssets } from '../../store/selectors/commonAreaAssets';


import { fetchPropertyCommonAreas } from '../../store/actions/properties';
import { fetchAllIssueTypes } from '../../store/actions/formOptions';
import Icon from '../Icon';
import Tile from '../Tile';
import { ICONS } from '../../common/constants';
import { fetchCommonAreaAssets } from '../../store/actions/CommonAreaAssets';
import { variables } from '../../Tenants';


class ServiceRequestFormSuite extends Component {
  loadProperties() {
    const { onFetchProperties, user } = this.props;
    onFetchProperties(user.id, user.roles[0].role.name);
  }

  loadSuites() {
    const { onFetchPropertySuites, serviceRequestFormData, user } = this.props;
    if (serviceRequestFormData.property_id) {
      onFetchPropertySuites(serviceRequestFormData.property_id, user.id, user.roles[0].role.name);
    }
  }

  loadSuite() {
    const { onFetchSuiteById, serviceRequestFormData } = this.props;
    if (serviceRequestFormData.suite_id) {
      onFetchSuiteById(serviceRequestFormData.suite_id);
    }
  }

  loadPropertyCommonAreas(){
    const { serviceRequestFormData, onFetchPropertyCommonAreas } = this.props;
    if(serviceRequestFormData.property_id){
      onFetchPropertyCommonAreas(serviceRequestFormData.property_id)
    }
  }

  componentDidMount() {
    this.loadProperties();
    this.loadSuites();
    this.loadPropertyCommonAreas();
    this.loadSuite();
    this.props.onFetchIssueTypes();  
    if(this.props.serviceRequestFormData && this.props.serviceRequestFormData.serviceRequestType) {
    } else {
      this.props.onSetServiceRequestFormData({
        serviceRequestType: 'Suite'
      })
    }
    const {from,onSetServiceRequestFormData,propertyData}=this.props
    if(from === "HomeOwnerDashboard"){
      onSetServiceRequestFormData({
        property_id: propertyData.propertyid,
        propertyId: propertyData.propertyId,
        suiteId:propertyData.suiteId,
        suite_id:propertyData.suite_id,
        serviceRequestType:'Suite'
      });
    }
  }

  componentDidUpdate(prevProps) {

    const { serviceRequestFormData, onFetchPropertySuites, onFetchSuiteById, onFetchPropertyCommonAreas,user } = this.props;

    if (prevProps.serviceRequestFormData.property_id !== serviceRequestFormData.property_id) {
      onFetchPropertySuites(serviceRequestFormData.property_id, user.id, user.roles[0].role.name);
      onFetchPropertyCommonAreas(serviceRequestFormData.property_id);

    }

    if (prevProps.serviceRequestFormData.suiteId !== serviceRequestFormData.suite_id) {
      onFetchSuiteById(serviceRequestFormData.suite_id);
    }
  }

  handleOnChangeProperty(e) {
    const { onSetServiceRequestFormData,onClearFetchedSuites,onClearFetchedAssets,serviceRequestFormData } = this.props;
    if(serviceRequestFormData.suiteId && serviceRequestFormData.suiteId !== ''){
      onSetServiceRequestFormData({
        property_id: e.target.value,
        propertyId: e.target.value,
        suite_id:'',
        suiteId:'',
        serviceRequestType:'Suite',
        asset_item_id: '',
        asset_item_nameDescription: '',
        assetId: ''
      });
    }else{
      onSetServiceRequestFormData({
        property_id: e.target.value,
        propertyId: e.target.value,
        serviceRequestType:'Suite',
        asset_item_id: '',
        asset_item_nameDescription: '',
        assetId: ''
      });
    }
    
    onClearFetchedSuites()
    onClearFetchedAssets()
  }

  handleOnChangeSuite(e) {
    const { onSetServiceRequestFormData,onfetchAssetsBySuiteId,suites } = this.props;
    onSetServiceRequestFormData({
      suite_id: e.target.value,
      suiteId: e.target.value,
      suiteFloorPLan:suites.filter( data => data.id === e.target.value)[0].floorPlanURL,
      annotatateImage: false,
      asset_item_id: '',
      asset_item_nameDescription: '',
      assetId: ''
    });
    onfetchAssetsBySuiteId(e.target.value);
   
  }

  handleOnChangeCommonArea(e) {
    const { onSetServiceRequestFormData,onFetchCommonAreaAssets,propertyCommonAreas } = this.props;
    
    onSetServiceRequestFormData({
      CommonAreaId: e.target.value,
      CommonArea: propertyCommonAreas && propertyCommonAreas.commonAreas ? propertyCommonAreas.commonAreas.filter( data => data.id === e.target.value)[0].customLabel ? propertyCommonAreas.commonAreas.filter( data => data.id === e.target.value)[0].customLabel : propertyCommonAreas.commonAreas.filter( data => data.id === e.target.value)[0].name : '',
      IsServiceRequest:'CommonArea'
    });
    onFetchCommonAreaAssets(e.target.value);
  }


  handleNext() {
    const { serviceRequestFormData,onSetServiceRequestFormNextStep, onSetServiceRequestFormData,onSetServiceRequestFormStep, user } = this.props;
    onSetServiceRequestFormData({
      creatorId: user.id
    });
    // if(serviceRequestFormData.CommonAreaId){
    //   onSetServiceRequestFormStep(2)
    // }else{
      onSetServiceRequestFormNextStep();
    // }
    
  }

  render() {
    let configureType = ['Suite', 'Common Area'];
    const { properties, property, suites, suite, propertyCommonAreas, serviceRequestFormData, onExitServiceRequestForm, onClose, onExit, user, propertyDisabled } = this.props;
    const role = user.roles[0].role.name;
    let filteredPropertyCommonAreas = [];
    if( serviceRequestFormData && serviceRequestFormData.property_id ){
      if( propertyCommonAreas.commonAreas && propertyCommonAreas.commonAreas.length > 0){
        filteredPropertyCommonAreas = propertyCommonAreas.commonAreas.filter( data => data.assetsCount !== 0)
      }
    }
    if(filteredPropertyCommonAreas.length === 0 || role === "Home Owner" || role === "Occupant"){
      configureType = ['Suite'];
    }
    return (
      <Form
        headline={`Start Your ${variables.serviceRequest}`}
        strapline="First, tell us which unit this request is for."
        onClose={() => {
          onExitServiceRequestForm()
          if (onClose) onClose();
        }}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={(
          <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >
              <Select
                value={serviceRequestFormData.property_id}
                label="Property"
                placeholder="(Select Property) "
                onChange={e => this.handleOnChangeProperty(e)}
                options={properties.map(property => ({ label: property.name, value: property.id }))}
                disabled = {this.props.propertyDisabled ? this.props.propertyDisabled : false}
              />
             <Row>
             {configureType.map((configType, i) => (
                  <div style={{padding:'0.5rem',flexDirection: 'row'}}>
                    <Tile
                      onClick={e => this.props.onSetServiceRequestFormData({ serviceRequestType: configType, suite_id: '', suiteId: '', CommonAreaId: null, IsServiceRequest:''})}
                      active={configType === serviceRequestFormData.serviceRequestType}
                      title={configType === 'Suite' ? variables.Suite : configType}
                      size="veryTiny"
                    />
                  </div>
                ))}
            </Row>
              { serviceRequestFormData.serviceRequestType === 'Suite' ? <Select
                value={serviceRequestFormData.suite_id}
                label={variables.Suite}
                placeholder={`(Select ${variables.Suite})`}
                onChange={e => this.handleOnChangeSuite(e)}
                options={ 
                  serviceRequestFormData.property_id ? 
                  suites.map(suite => ({ label: suite.number, value: suite.id })) : 
                  []
                  }
              />

             :
                 <Select
                value={serviceRequestFormData.CommonAreaId}
                label="Common Area"
                placeholder="(Select Common Area)"
                onChange={e => this.handleOnChangeCommonArea(e)}
                options={ serviceRequestFormData.property_id ? propertyCommonAreas && propertyCommonAreas.commonAreas ? propertyCommonAreas.commonAreas.map( c => ({label: c.customLabel ? c.customLabel : c.name,value:c.id})) : [] : []}
              />}

              <div className="serviceRequestFormSuite"  style={{marginBottom: "100px;"}}>
                <div
                  className="serviceRequestFormSuite__image"
                  style={{
                    backgroundImage: `url(${property ? property.image : ''})`,
                  }}
                />
                <div className="serviceRequestFormSuite__address">
                  { property ? (
                    <>
                      <div className="serviceRequestFormSuite__title">{property.name} {suite ? ' / ' + suite.number : ''}</div>
                      {property.addressLine1}<br />
                      {property.city}, {property.province}<br />
                      {property.postalCode}
                    </>
                  ) : (
                    <>
                      <div className="serviceRequestFormSuite__title">Property / Suite</div>
                      Street Address<br />
                      City, Province<br />
                      Postal Code
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
        footer={(
          <div style={{position: "fixed",
          bottom: "0",left:'0',
          width: "100%",
          background: "#fff", padding:'15px',     boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)'}}>
          <Button
            color="teal"
            size="small"
            label="Next: Select Room / Item"
            onClick={() => this.handleNext()}
            disabled={!serviceRequestFormData.property_id || serviceRequestFormData.CommonAreaId ? !serviceRequestFormData.CommonAreaId : !serviceRequestFormData.suite_id}
          />
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceRequestFormData = selectServiceRequestFormData(state);
  const CommonAreaId = serviceRequestFormData.CommonAreaId ? serviceRequestFormData.CommonAreaId : null;

  return {
    properties: selectProperties(state),
    property: selectPropertyById(state, serviceRequestFormData.property_id),
    suites: selectSuites(state),
    suite: selectSuiteById(state, serviceRequestFormData.suite_id),
    propertyCommonAreas:selectPropertyCommonAreas(state),
    // commonArea:selectCommonAreaById(state,CommonAreaId),
    serviceRequestFormData: selectServiceRequestFormData(state),
    user:selectAuthenticatedUser(state),
    assets: selectCommonAreaAssets(state),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchProperties: fetchProperties,
  onFetchPropertySuites: fetchPropertySuites,
  onClearFetchedSuites: clearSuites,
  onClearFetchedAssets:clearAssets,
  onFetchSuiteById: fetchSuiteById,
  onfetchAssetsBySuiteId: fetchSuiteAssets,
  onSetServiceRequestFormData: setServiceRequestFormData,
  onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
  onSetServiceRequestFormStep: setServiceRequestFormStep,
  onExitServiceRequestForm: exitServiceRequestForm,
  onFetchPropertyCommonAreas:fetchPropertyCommonAreas,
  onFetchIssueTypes: fetchAllIssueTypes,
  onFetchCommonAreaAssets:fetchCommonAreaAssets
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestFormSuite);
